import { Box, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useTarefa } from "../../../../../contexts/TarefaContext";
import { Dia, IAgendamentoMensal, Mes } from "../../../../../types/tarefa";
import { BFChangeInput } from "../../../../../types/components";

const tituloMeses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
const dias: Array<Dia> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];

interface IDiaMes {
    selecionado: boolean;
    dia: Dia;
}

interface IMesSelecao {
    selecionado: boolean;
    titulo: string;
    mes: Mes;
}

const AgendamentoMensal = () => {
    const [tarefa, setTarefa] = useTarefa();
    const agendamento = (tarefa.agendamento || {}) as IAgendamentoMensal;
    const diasIniciais = agendamento.dias || [];
    const mesesIniciais = agendamento.meses || [];

    const diasMesInicial: Array<IDiaMes> = [];
    dias.forEach(dia => {
        diasMesInicial.push({
            dia,
            selecionado: diasIniciais.includes(dia)
        });
    });

    const mesesInicial: Array<IMesSelecao> = [];
    tituloMeses.forEach((titulo, indice) => {
        const m = (indice + 1) as Mes;
        mesesInicial.push({
            titulo,
            mes: m,
            selecionado: mesesIniciais.includes(m)
        });
    });

    const [diasMes, setDiasMes] = useState<IDiaMes[]>(diasMesInicial);
    const [meses, setMeses] = useState<IMesSelecao[]>(mesesInicial);

    function handleSelecionarTodosMeses(event: BFChangeInput): void {
        const novoEstado = meses.map((mes) => ({ ...mes, selecionado: event.target.checked }));
        setMeses(novoEstado);
        atualizarTarefa(diasMes, novoEstado);
    }

    function handleSelecionarTodosDias(event: BFChangeInput): void {
        const novoEstado = diasMes.map((diaMes) => ({ ...diaMes, selecionado: event.target.checked }));
        setDiasMes(novoEstado);
        atualizarTarefa(novoEstado, meses);
    }

    function handleSelecaoDiaMesAlterado(event: BFChangeInput): void {
        event.preventDefault();

        const novoEstado = diasMes.map((diaMes) => {
            if (diaMes.dia === Number(event.target.name))
                return { ...diaMes, selecionado: event.target.checked };
            else
                return { ...diaMes };
        });

        setDiasMes(novoEstado);
        atualizarTarefa(novoEstado, meses);
    }

    function handleSelecaoMesAlterado(event: BFChangeInput): void {
        event.preventDefault();

        const novoEstado = meses.map((mes) => {
            if (mes.mes === Number(event.target.name))
                return { ...mes, selecionado: event.target.checked };
            else
                return { ...mes };
        });

        setMeses(novoEstado);
        atualizarTarefa(diasMes, novoEstado);
    }

    function atualizarTarefa(estadoDias: IDiaMes[], estadoMeses: IMesSelecao[]): void {
        const novoAgendamento = { ...agendamento };
        novoAgendamento.dias = estadoDias
            .filter((diaMes) => diaMes.selecionado)
            .map((diaMes) => diaMes.dia);

        novoAgendamento.meses = estadoMeses
            .filter((mes) => mes.selecionado)
            .map((mes) => mes.mes);

        setTarefa({
            ...tarefa,
            agendamento: novoAgendamento
        });
    }

    return (
        <Box sx={{ marginTop: '25px' }}>
            <Grid container>
                <Grid lg={12} md={12} xs={12} item>
                    <FormControlLabel 
                        control={<Checkbox 
                            onChange={handleSelecionarTodosMeses} 
                            checked={meses.every(m => m.selecionado)} 
                        />} 
                        label="Selecionar todos os meses" 
                    />
                </Grid>

                {meses.map((mes, indice) => (
                    <Grid key={indice} lg={3} md={4} item>
                        <FormControlLabel control={<Checkbox
                            name={mes.mes.toString()}
                            onChange={handleSelecaoMesAlterado}
                            checked={mes.selecionado} />}
                            label={mes.titulo} />
                    </Grid>
                ))}
            </Grid>

            <Typography variant="h6" sx={{ marginTop: '16px', marginBottom: '16px' }}>Dias</Typography>

            <Grid container>
                <Grid lg={12} md={12} xs={12} item>
                    <FormControlLabel 
                        control={<Checkbox 
                            onChange={handleSelecionarTodosDias} 
                            checked={diasMes.every(d => d.selecionado)} 
                        />} 
                        label="Selecionar todos os dias" 
                    />
                </Grid>

                {diasMes.map((diaMes, indice) => (
                    <Grid key={indice} lg={3} md={4} item>
                        <FormControlLabel control={<Checkbox
                            name={diaMes.dia.toString()}
                            onChange={handleSelecaoDiaMesAlterado}
                            checked={diaMes.selecionado} />}
                            label={diaMes.dia.toString()} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default AgendamentoMensal;